import { FormOptionCardLabels } from "app/components/FormOptionCard";
import { useSelector } from "react-redux";

import { selectQuoteAccessories } from "../redux/selector";
import { formKey } from "./useQuoteBoxStructure";

export const tyingKey = (suffix: string) =>
  formKey(`TYING_EQUIPMENT.${suffix}`);
export const safetyKey = (suffix: string) =>
  formKey(`SAFETY_VEHICLE.${suffix}`);
export const locksKey = (suffix: string) => formKey(`LOCKS.${suffix}`);
export const standardKey = (suffix: string) => formKey(`STANDARD.${suffix}`);

export const tyingLabels: FormOptionCardLabels = {
  note: tyingKey("FIELDS.NOTE"),
  quantity: tyingKey("FIELDS.QUANTITY"),
  size: tyingKey("FIELDS.QUANTITY"),
  location: tyingKey("FIELDS.QUANTITY_OPTION"),
  itemType: tyingKey("FIELDS.TYPE"),
};

export const safetyLabels: FormOptionCardLabels = {
  note: safetyKey("FIELDS.NOTE"),
  quantity: safetyKey("FIELDS.QUANTITY"),
  size: safetyKey("FIELDS.ROUND_IRON_DIAMETER"),
  location: safetyKey("FIELDS.LOCATION"),
  itemType: safetyKey("FIELDS.MATERIAL"),
};

export const locksLabels: FormOptionCardLabels = {
  note: locksKey("FIELDS.NOTE"),
  quantity: locksKey("FIELDS.NOTE"),
  size: locksKey("FIELDS.NOTE"),
  location: locksKey("FIELDS.NOTE"),
  itemType: locksKey("FIELDS.TYPE"),
};

export const standardLabels: FormOptionCardLabels = {
  note: standardKey("FIELDS.NOTE"),
  quantity: standardKey("FIELDS.NOTE"),
  size: standardKey("FIELDS.NOTE"),
  location: standardKey("FIELDS.NOTE"),
  itemType: standardKey("FIELDS.TYPE"),
};

export const useQuoteAccessories = () =>
  useSelector(selectQuoteAccessories);
